
import { useLogout } from '@platyplus/vue-hasura-backend-plus'
import { useToggle } from '@vueuse/core'
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import { useDB, useDisplayName, useInitial, useProfile } from '../composables'

export default defineComponent({
  name: 'Profile',
  setup() {
    const db = useDB()
    const [expanded, toggle] = useToggle(false)
    const router = useRouter()
    const hbpLogout = useLogout()
    const profile = useProfile()
    const logout = async () => {
      await hbpLogout()
      // * destroy RXDB databases as well
      // ? => in vue-rxdb plugin ?
      // TODO not sure it's working
      await db.value?.remove()
      router.push({ name: 'root' })
    }
    const displayName = useDisplayName(profile)
    const initial = useInitial(displayName)
    return { expanded, toggle, logout, profile, displayName, initial }
  }
})
